import { Helmet } from 'react-helmet';
import Layout from '../../../layouts/Layout';
import ProgramsState from '../../../context/Programs/ProgramsState';
import Index from "../../../presentation/components/ProgramsList/Index";
import { APP_NAME } from '../../../config/app/app';
import ProgramsListProvider from '../../../application/context/Programs/ProgramsList/ProgramsListContext';
import React from "react";

export default function SettingsPrograms() {
    return (
        <ProgramsListProvider>
            <Helmet>
                <title>Programas - {APP_NAME}</title>
            </Helmet>

            <Layout>
                <ProgramsState>
                    <Index />   
                </ProgramsState>
            </Layout>
        </ProgramsListProvider>
    )
}